import getCurrentSiteBusinessUnit from './getCurrentSiteBusinessUnit';

const isModellinkSite = () => {
  return getCurrentSiteBusinessUnit() === 'modellink'
}

export default isModellinkSite
